import { useCallback, useEffect, useState } from 'react';
import { getCurrentPosition, reverseGeocode, nearbyLocations, type LocationResult } from '../services/locationService';
import { peekCachedMapCenter } from '../utils/mapCenter';

export function useCurrentLocation(autoLoad = false) {
  const [coords, setCoords] = useState<{ lat: number; lng: number } | null>(peekCachedMapCenter());
  const [address, setAddress] = useState<LocationResult | null>(null);
  const [nearby, setNearby] = useState<LocationResult[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const pos = await getCurrentPosition();
      setCoords(pos);
      const [rev, near] = await Promise.all([
        reverseGeocode(pos.lat, pos.lng),
        nearbyLocations(pos.lat, pos.lng, 5),
      ]);
      setAddress(rev);
      setNearby(near.filter((n: LocationResult) => n.type !== 'current'));
    } catch (e) {
      setError((e as Error).message || 'Location unavailable');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (autoLoad) load();
  }, [autoLoad, load]);

  return { coords, address, nearby, loading, error, load };
}
